class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverTarget = this.closest('li') || this;
    this.closeTimer = null;

    this.hoverTarget.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.hoverTarget.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  isDesktopPointer() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  onPointerEnter() {
    if (!this.isDesktopPointer()) return;
    window.clearTimeout(this.closeTimer);
    this.open();
  }

  onPointerLeave() {
    if (!this.isDesktopPointer()) return;
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => {
      if (this.hoverTarget.matches(':hover') || this.content.matches(':hover')) return;
      this.close();
    }, 320);
  }

  onSummaryClick(event) {
    if (!this.isDesktopPointer() || event.detail === 0) return;
    event.preventDefault();
    this.open();
  }

  open() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
